import { render, staticRenderFns } from "./CopyClipButton.vue?vue&type=template&id=7dc44bb0&"
import script from "./CopyClipButton.vue?vue&type=script&lang=js&"
export * from "./CopyClipButton.vue?vue&type=script&lang=js&"
import style0 from "./CopyClipButton.vue?vue&type=style&index=0&id=7dc44bb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports